
import { Component, inject, OnChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { ModelService } from '../../../services/model-service';
import { ConfigurationSection, UserStateService } from '../../../services/user-state.service';
import { GuruEntity } from '../../../model/guru-entity';
import { SelectionUtils } from '../../selection-utils';

@Component({
  selector: 'app-enviro-kit-primary-valve-package',
  imports: [MatIcon, FormsModule],
  templateUrl: './enviro-kit-primary-valve-package.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './enviro-kit-primary-valve-package.component.css'
})
export class EnviroKitPrimaryValvePackageComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);
  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  packageSizeSelection!: GuruEntity;
  flowControlTypeSelection!: GuruEntity;
  controlValveSelection!: GuruEntity;
  hoseKitSelection!: GuruEntity;
  isolationBallValveSelection!: GuruEntity;
  normallyOpenSelection!: GuruEntity;
  serviceFittingsSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.PRIMARY_VALVE_PACKAGE;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.packageSizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryValveSize');
    this.flowControlTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryFlowCntl');
    this.controlValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryControlValve');
    this.hoseKitSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryIsolation');
    this.isolationBallValveSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryIsolationBallValve');
    this.normallyOpenSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USNOvalve1');
    this.serviceFittingsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPrimaryServcFitting');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
    entity.Value = newValue;
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
